import { useState } from 'react';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { Warning } from '@phosphor-icons/react';
import axios from 'axios';
import { toast } from 'sonner';
import { saveAuthData } from '@/utils/auth';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

export const LoginForm = ({ onAuthSuccess, onForgotPassword }) => {
  const [loading, setLoading] = useState(false);
  const [loginData, setLoginData] = useState({ email: '', password: '' });
  const [errors, setErrors] = useState({});

  const handleLogin = async (e) => {
    e.preventDefault();
    setErrors({});
    setLoading(true);
    try {
      const response = await axios.post(`${API}/auth/login`, loginData);
      saveAuthData(response.data.access_token, response.data.user);
      toast.success('Welcome back!');
      onAuthSuccess(response.data.user);
    } catch (error) {
      const msg = error.response?.data?.detail || 'Login failed';
      setErrors({ form: msg });
    } finally {
      setLoading(false);
    }
  };

  return (
    <form onSubmit={handleLogin} className="space-y-4">
      {errors.form && (
        <div className="flex items-start gap-2 p-3 bg-red-50 border border-red-200 text-red-700 text-sm" data-testid="login-error">
          <Warning size={18} weight="fill" className="mt-0.5 flex-shrink-0" />
          <span>{errors.form}</span>
        </div>
      )}
      <div className="space-y-2">
        <Label htmlFor="login-email">Email</Label>
        <Input
          id="login-email"
          type="email"
          placeholder="you@example.com"
          value={loginData.email}
          onChange={(e) => setLoginData({ ...loginData, email: e.target.value })}
          required
          data-testid="login-email-input"
          className="border-[#E4E4E7]"
        />
      </div>
      <div className="space-y-2">
        <div className="flex items-center justify-between">
          <Label htmlFor="login-password">Password</Label>
          <button
            type="button"
            onClick={onForgotPassword}
            className="text-xs text-[#0047FF] hover:underline"
            data-testid="forgot-password-link"
          >
            Forgot password?
          </button>
        </div>
        <Input
          id="login-password"
          type="password"
          placeholder="••••••••"
          value={loginData.password}
          onChange={(e) => setLoginData({ ...loginData, password: e.target.value })}
          required
          data-testid="login-password-input"
          className="border-[#E4E4E7]"
        />
      </div>
      <Button
        type="submit"
        className="w-full bg-[#0047FF] hover:bg-[#0037CC] text-white transition-transform hover:-translate-y-0.5"
        disabled={loading}
        data-testid="login-submit-button"
      >
        {loading ? 'Logging in...' : 'Login'}
      </Button>
    </form>
  );
};
